import { filter, map, trimEnd } from "lodash";
import { FileAttachment, ImageAttachment } from "../../../@types/activities.ts";
import usePublishAllVolatile from "../../../helpers/files/usePublishAllVolatile.ts";

export default function useProcessActivityFiles() {
  const publishAllVolatile = usePublishAllVolatile();

  return async (
    fileAttachments: (File | FileAttachment | ImageAttachment)[],
    type: "files" | "images",
  ) => {
    let files: File[] = [];

    const result = await publishAllVolatile({
      values: {
        files: fileAttachments,
      },
      storageDirectory: type,
    });

    files = map(result.files, (file) =>
      file.state
        ? {
            ...file,
            file_object_id: file.id,
            id: null,
            type: trimEnd(type, "s"),
          }
        : file,
    );

    return filter(files, (file) => file["state"] !== "removed");
  };
}
